export class PGGInstrumentation {
  constructor(options) {
    const { instrumentation, viewType } = options;
    const scenario = instrumentation.newUIProductGroupsPageScenario.create();

    this.viewType = viewType;
    this.activity = scenario.PGGActivity.create();
  }

  signal(message) {
    try {
      const str = JSON.stringify({ ...message, viewType: this.viewType });

      this.activity.signal(str);
    } catch (e) {
      console.log(e.stack); // eslint-disable-line
    }
  }

  sendEnterPageLog() {
    this.signal({
      messageType: 'ENTER_PAGE',
    });
  }

  sendSwitchViewLog(viewType) {
    this.signal({
      messageType: 'SWITCH_VIEW',
      viewType,
    });
  }

  sendModifyPGLog(params) {
    this.signal({
      messageType: 'MODIFY_PG_SUCCESS',
      params,
    });
  }

  sendModifyPGErrorLog(message) {
    this.signal({
      messageType: 'MODIFY_PG_ERROR',
      message,
    });
  }

  sendInlineEditErrorLog(message) {
    this.signal({
      messageType: 'INLINE_EDIT_ERROR',
      error: message,
    });
  }

  sendInlineEditLog(data) {
    this.signal({
      messageType: 'INLINE_EDIT',
      data,
    });
  }

  sendBulkEditLog(model) {
    const BatchAction = model.get('BatchAction');
    const TotalRowCounnt = model.get('TotalRowCount');
    const SuccessRowCount = model.get('SuccessRowCount');
    const ErrorRowCount = model.get('ErrorRowCount');
    this.signal({
      messageType: 'BULK_EDIT',
      model: {
        BatchAction,
        TotalRowCounnt,
        SuccessRowCount,
        ErrorRowCount,
      },
    });
  }

  sendToProductDetailsPageLog() {
    this.signal({
      messageType: 'TO_PRODUCT_DETAILS',
    });
  }
}
